import { useState } from "react";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomDropdown from "../../../Components/Dropdown/CustomDropdown";
import CustomizableTableForAddAndEdit from "../../../Components/Tables/CustomizableTableForAddAndEdit";
import { DataFromAPI2 } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import TransferItemFormStructure from "../../../Shared/Forms/TransferItemFormStructure";
import { locations } from "../../../Data/stockTransfer";
import { useNavigate } from "react-router-dom";

const TransferByLocation = () => {
  const pageName = `Stock Transfer`;
  interface DataRow {
    [key: string]: any; // Allow any key-value pairs
  }

  const [tableData, setTableData] = useState<DataRow[]>([]);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/inventory/stock-transfer");
  };

  const handleSelect = (
    selectedItem: any,
    rowIndex: number,
    columnKey: string
  ) => {
    // Filter the data from DataFromAPI2 based on the selected item
    const matchedRow = DataFromAPI2.find(
      (data) => data.fromBin === selectedItem.location
    );

    if (matchedRow) {
      // Update the tableData with the matched row
      const updatedData = [...tableData];
      updatedData[rowIndex] = {
        ...matchedRow,
        [columnKey]: selectedItem.location,
      };
      setTableData(updatedData);
    }
  };

  const columns = [
    { key: "lineNumber", label: "Line", disable: true },
    {
      key: "fromBin",
      label: "From Bin",
      inputType: (
        <CustomDropdown
          data={locations}
          handleSelect={(item) => handleSelect(item, 0, "fromBin")}
        />
      ),
      disable: true,
      customStyles: {width:"25%"},
      customStyleForBody: {width:"25%"},
    },
    { key: "availableQty", label: "Available Qty", disable: true },
    {
      key: "toBin",
      label: "To Bin",
      disable: true,
      inputType: (
        <CustomDropdown
          data={locations}
          handleSelect={(item) => handleSelect(item, 0, "toBin")}
        />
      ),
    },
  ];

  const inputs = [
    <>
      <label className="fw-bold">Transfer Date</label>
      <div className="mt-2">
        <input
          tabIndex={1}
          autoFocus={true}
          maxLength={50}
          type="date"
          name="transferDate"
          className="form-control"
          placeholder="Transfer Date"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">From Inv Status</label>
      <div className="mt-2">
        <input
          tabIndex={2}
          maxLength={50}
          type="text"
          name="fromInvStatus"
          className="form-control"
          placeholder="Inventory Status"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">To Inv Status</label>
      <div className="mt-2">
        <input
          tabIndex={3}
          maxLength={50}
          type="text"
          name="toInvStatus"
          className="form-control"
          placeholder="Enter To Inventory Status"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">Custom Field 1</label>
      <div className="mt-2">
        <input
          tabIndex={4}
          maxLength={50}
          type="text"
          name="customField1"
          className="form-control"
          placeholder="Enter Custom Field 1"
        />
      </div>
    </>,
    <>
      <label className="fw-bold">Custom Field 2</label>
      <div className="mt-2">
        <input
          tabIndex={5}
          maxLength={50}
          type="text"
          name="customField2"
          className="form-control"
          placeholder="Enter Custom Field 2"
        />
      </div>
    </>,
  ];

  return (
    <>
      <PageHeader
        addUrl="/inbound/asn/overview/add"
        listUrl="/inventory/stock-transfer"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2">
        <TransferItemFormStructure inputFields={inputs} />
      </div>
      <div className="my-2 bg-white rounded p-4 customTableDiv">
        <CustomizableTableForAddAndEdit
          columns={columns}
          initialData={[]}
          dataFromAPI={DataFromAPI2}
          filterColumn="fromBin"
          tableDataFilteredFromCustomDropdown={tableData}
        />
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleBack()}
          >
            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleBack()}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
};

export default TransferByLocation;
